import { Injectable, InjectionToken } from '@angular/core';
export const storageServiceToken = new InjectionToken('storage.service');

@Injectable()
export class StorageService {

    public setSession(key: string, value: any) {
        try {
            /* istanbul ignore else */
            if (sessionStorage) {
                sessionStorage.setItem(key, JSON.stringify(value));
            }
        } catch (e) {
            /* istanbul ignore next */
            console.error(e);
        }
    }

    public getSession(key) {
        try {
            /* istanbul ignore else */
            if (sessionStorage) {
                const data = sessionStorage.getItem(key);

                return this.handleData(data);
            }
        } catch (e) {
            /* istanbul ignore next */
            console.error(e);
        }
    }

    public removeSession(key) {
        try {
            /* istanbul ignore else */
            if (sessionStorage) {
                sessionStorage.removeItem(key);
            }
        } catch (e) {
            /* istanbul ignore next */
            console.error(e);
        }
    }

    private handleData(data) {
        let value = null;
        /* istanbul ignore else */
        if (data) {
            value = JSON.parse(data);
        }

        return value;
    }
}
